export const lookupElement = ({ type, id, state, toJS = false }) => {
    // PlainJS : state.interactiveElements[type].byId[id]
    const el = state.getIn(['interactiveElements', type, 'byId', String(id)])
    if (!el) {
        throw new Error(`Cannot find element id: ${id}, type: ${type}`)
    }
    return toJS ? el.toJS() : el
}
